import type { CreditPurchaseConfig, FixedProductInput } from '@vy/types';
import type { CreditGrantView } from './credit-grant-view';

export type CreditArrays<P = FixedProductInput> = {
  credits: CreditPurchaseConfig[];
  fixedProducts: P[];
};

type CreditMutation<P> =
  | { field: 'credits'; value: CreditPurchaseConfig[] }
  | { field: 'fixedProducts'; value: P[] };

type RowRef = Pick<CreditGrantView, 'source' | 'index'>;

type CreditProduct = { name?: string | null; creditPurchaseConfig?: CreditPurchaseConfig | null };

export function applyCreditEdit<P extends CreditProduct>(
  arrays: CreditArrays<P>,
  row: RowRef,
  config: CreditPurchaseConfig,
): CreditMutation<P> {
  if (row.source === 'fixedProducts') {
    const value = arrays.fixedProducts.map((product, index) =>
      index === row.index ? ({ ...product, name: config.name, creditPurchaseConfig: config } as P) : product,
    );
    return { field: 'fixedProducts', value };
  }

  const value = arrays.credits.map((credit, i) => (i === row.index ? config : credit));
  return { field: 'credits', value };
}

export function applyCreditRemoval<P>(arrays: CreditArrays<P>, row: RowRef): CreditMutation<P> {
  if (row.source === 'fixedProducts') {
    return {
      field: 'fixedProducts',
      value: arrays.fixedProducts.filter((_product, index) => index !== row.index),
    };
  }

  return { field: 'credits', value: arrays.credits.filter((_c, i) => i !== row.index) };
}
